import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useFormTcfVendor } from "../../../../../contexts/formTcfVendor.js";
import { useI18n } from "../../../../../contexts/i18n.js";
const FormTcfVendorFieldGeneralProvider = ()=>{
    const { __ } = useI18n();
    const { vendor: { id, name } } = useFormTcfVendor();
    return /*#__PURE__*/ _jsx(Form.Item, {
        label: __("Provider"),
        children: /*#__PURE__*/ _jsx(Input, {
            value: name,
            readOnly: true,
            addonAfter: __("Vendor ID: %d", id)
        })
    });
};
export { FormTcfVendorFieldGeneralProvider };
